import React from 'react';
import styled from 'styled-components';
import { type HSIcon, HSIconType, ImageType } from '@types';
import Image from '@components/Image';
import Icon from '@components/Icon';
import { getSysUrl } from '@utils/urlMakers';
import ImgText from './icon-text.png';
import ImgVideo from './icon-video.png';
import ImgPolygon from './icon-polygon.png';
import ImgSeqFrame from './icon-seq-frame.png';

interface Props {
  icon: Partial<HSIcon>;
}

const SysIcon = styled.div<{ url: string }>`
  width: 16px;
  height: 16px;
  background-image: ${({ url }) => `url(${url})`};
  background-size: 100%;
  background-repeat: no-repeat;
  flex-shrink: 0;
`;

function ItemIcon({ icon }: Props) {
  switch (icon.type) {
    case HSIconType.system: {
      return <SysIcon url={getSysUrl(icon.url)} />;
    }
    case HSIconType.mark:
      return <Icon className="flex-shrink-0" src={ImgText} />;
    case HSIconType.image:
      return (
        <Image
          className="h-16 w-16 flex-shrink-0"
          src={icon.media![0].url}
          type={ImageType.media}
          size={16}
        />
      );
    case HSIconType.video:
      return <Icon className="flex-shrink-0" src={ImgVideo} />;
    case HSIconType.seqFrame:
      return <Icon className="flex-shrink-0" src={ImgSeqFrame} />;
    case HSIconType.polygon:
      return <Icon className="flex-shrink-0" src={ImgPolygon} />;
    default:
      return null;
  }
}

export default ItemIcon;
